import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/properties`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/properties/${id}?include=organization,auction,owners,awarders,allowedLocations,createdBy,updatedBy,paymentReceivedBy,registrationDivision`,
      options
    )
    .then((response) => {
      let property = jsona.deserialize(response.data);
      delete property.links;
      return property;
    });
}

function add(property) {
  const payload = jsona.serialize({
    stuff: property,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/properties?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(property) {
  const payload = jsona.serialize({
    stuff: property,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/properties/${property.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/properties/${id}`, options);
}

function byPayment(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/properties/${id}/by-payment`, options)
    .then((response) => {
      let property = jsona.deserialize(response.data);
      delete property.links;
      return property;
    });
}

function activate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/properties/${id}/activate`, options)
    .then((response) => {
      let property = jsona.deserialize(response.data);
      delete property.links;
      return property;
    });
}

function deactivate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/properties/${id}/deactivate`, options)
    .then((response) => {
      let property = jsona.deserialize(response.data);
      delete property.links;
      return property;
    });
}

function exportExcel(params) {
  const options = {
    params: params,
    responseType: "blob",
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return axios.get(`${url}/properties/exports`, options);
}

function printPdfLetters(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/print-letters`, data, options);
}

function exportThumbnails(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-thumbnails`,data, options);
}

function printLettersForSelection(data) {
  const options = {
    headers: {
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(
    `${url}/properties/print-letters-for-selection`,
    data,
    options
  );
}

function exportSuperiorCourtProperties(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-superior-court-properties`,data, options);
}

function exportPaidProperties(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-paid-properties`,data, options);
}

function exportPublicNotices(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-public-notices`,data, options);
}

function exportPdfPublicNotices(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-pdf-public-notices`,data, options);
}

function exportRtfPublicNotices(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-rtf-public-notices`,data, options);
}

function exportSoldProperties(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-sold-properties`,data, options);
}

function exportRtfSoldProperties(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-rtf-sold-properties`,data, options);
}

function exportUnsoldProperties(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-unsold-properties`, data, options);
}

function exportRtfUnsoldProperties(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-rtf-unsold-properties`,data, options);
}

function exportThumbnailsForSelection(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(
    `${url}/properties/export-thumbnails-for-selection`,
    data,
    options
  );
}

function printAccountStatus(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/print-account-status`,params, options);
}

function sendMailAccountStatus(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/properties/send-mail-account-status`, data,
      options
    )
    .then((response) => {
      let customer = jsona.deserialize(response.data);
      delete customer.links;
      return customer;
    });
}

function createTransaction(property) {
  const payload = jsona.serialize({
    stuff: property,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/properties/${property.id}/transactions`, property, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroyTransaction(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/properties/${id}/transactions`, options);
}

function importProperties(payload) {

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/properties/import-properties`, payload, options)
    .then((response) => {
      return response.data;
    });
}

function registrationDivisions(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/registration-divisions`, options).then((response) => {
    return jsona.deserialize(response.data);
  });
}

function printAwardCertificates(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/print-award-certificates`,params, options);
}

function printAwardCertificate(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/print-award-certificates`,params, options);
}

function exportMunicipalitiesSumsDue(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-municipalities-sums-dues`, data, options);
}

function exportPdfMunicipalitiesSumsDue(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/print-pdf-sums-dues`,data, options);
}

function exportPaymentsReceipts(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-payments-receipts`, data, options);
}

function exportPdfPaymentsReceipts(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/print-pdf-payments-receipts`,data, options);
}

function exportAppliedFees(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/export-applied-fees`, data, options);
}

function exportPdfAppliedFees(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/print-pdf-applied-fees`,data, options);
}

function confirm(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/properties/confirm`,data, options);
}

function cancel(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/properties/cancel`,data, options);
}

function assignMrcFees(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/properties/assign-mrc-fees`,data, options);
}

function exportArchive(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/exports-archives`,data, options);
}

function shippingSavedLetters(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/shipping-saved-letters`,data, options);
}

function estimateShippingSavedLetters(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/estimate-shipping-saved-letters`,data, options);
}


function createShippingSavedLetters(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/create-shipping-saved-letters`,data, options);
}

function cancelShippingSavedLetters(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/cancel-shipping-saved-letters`,data, options);
}


function getShipmentsForPickup(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/get-shipments-for-pickup`,data, options);
}


function createPickup(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/create-shipping-pickup`,data, options);
}


function cancelPickup(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/cancel-shipping-pickup`,data, options);
}

function extractPropertyDetails(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties/extract-prperty-details`,data, options);
}


export default {
  list,
  get,
  add,
  printAccountStatus,
  sendMailAccountStatus,
  update,
  destroy,
  activate,
  deactivate,
  exportExcel,
  printPdfLetters,
  exportThumbnails,
  importProperties,
  createTransaction,
  destroyTransaction,
  exportPublicNotices,
  exportPaidProperties,
  exportSoldProperties,
  registrationDivisions,
  exportUnsoldProperties,
  exportPdfPublicNotices,
  printLettersForSelection,
  exportThumbnailsForSelection,
  exportSuperiorCourtProperties,
  byPayment,
  printAwardCertificates,
  exportMunicipalitiesSumsDue,
  exportPdfMunicipalitiesSumsDue,
  exportPaymentsReceipts,
  exportPdfPaymentsReceipts,
  confirm,
  cancel,
  exportRtfPublicNotices,
  exportRtfUnsoldProperties,
  exportRtfSoldProperties,
  exportAppliedFees,
  exportPdfAppliedFees,
  assignMrcFees,
  exportArchive,
  shippingSavedLetters,
  estimateShippingSavedLetters,
  createShippingSavedLetters,
  cancelShippingSavedLetters,
  getShipmentsForPickup,
  createPickup,
  cancelPickup,
  extractPropertyDetails,
};
